<script setup lang="ts">
  import { ref } from 'vue'
  import TheNavbar from './_components/navbar/the-navbar.vue'
  import TheSidebar from './_components/sidebar/the-sidebar.vue'

  const showSidebarMobile = ref(false)
</script>

<template>
  <div>
    <the-navbar
      class="left-0 lg:left-40"
      @open-sidebar="showSidebarMobile = true" />

    <the-sidebar v-model="showSidebarMobile" />

    <div class="pt-12 lg:pl-40">
      <div class="px-2 py-4 lg:px-4">
        <div class="min-h-[calc(100vh-96px)]">
          <app-router-view />
        </div>
      </div>
    </div>
  </div>
</template>
